import React from 'react'
import LegalFormalityDocumentContextProvider from 'contexts/LegalFormalityDocumentContext'
import { documentListItemType, LegalDocumentType } from 'types'
import DocumentsTabView from './DocumentsTabView'

export const findDoc = (
  documents: LegalDocumentType[],
  documentListItem: documentListItemType
) => {
  if (!documentListItem) return

  return documents.find((d: LegalDocumentType) => {
    const check =
      d.documentType === documentListItem.documentType &&
      d.legalDocumentableType === documentListItem.target?.type &&
      d.legalDocumentableId === documentListItem.target?.id

    return check
  })
}

export const isDocPresent = (
  documents: LegalDocumentType[],
  documentListItem: documentListItemType
) => {
  return !!findDoc(documents, documentListItem)
}

export const toDotSeparated = (text: string, separator = '_') => {
  return text.split(separator).join('.')
}
const Index = () => {
  return (
    <div>
      <LegalFormalityDocumentContextProvider>
        <DocumentsTabView />
      </LegalFormalityDocumentContextProvider>
    </div>
  )
}

export default Index
